import { useGetTableData } from "@/queries/data-center/data-center.api";
import ValueDisplay from "./value-display";

export default function DataCenterValue({
  value,
  table_name,
  column_name,
  table_source,
  oldValue,
}: Readonly<{
  table_name: string;
  column_name: string;
  table_source: string;
  value?: string | number | string[];
  oldValue?: boolean;
}>) {
  const { data, error } = useGetTableData(table_name, table_source, 1, [
    {
      name: "id",
      value: value as string,
      operator: "EQUALS",
      type: "STRING",
    },
  ]);
  if (!data && !error)
    return <span className="text-body">{"Cargando..."}</span>;

  if (error) return <span className="text-body">{"Error cargando datos"}</span>;

  const record = data?.data?.data?.[0];
  if (record) {
    return (
      <ValueDisplay isOldValue={oldValue}>
        {record[column_name as keyof typeof record] as string}
      </ValueDisplay>
    );
  }

  return <span className="text-body">{"—"}</span>;
}
